import React from "react";
import "../Started/Started.css";

function Started() {
  // Define two arrays of text to be displayed in the moving bar
  const textArray1 = [
    "Mining Exploration * Resource Extraction * Site Management * Mineral Processing * Environmental Services * Equipment Rental",
  ];

  const textArray2 = [
    "Mine Planning * Drilling Services * Safety Consulting * Excavation Services * Geotechnical Engineering * Environmental Monitoring",
  ];

  // Merge both arrays into one
  const combinedTextArray = [...textArray1, ...textArray2];

  return (
    <div className="main-container">
      <div className="content-wrapper">
        <div className="left-div">
          <h1>*</h1>
          <h2>
            <span className="highlight">Launching</span> a mining company to
            serve you
          </h2>
          <button className="contact-buttonn">Contact Us</button>
        </div>
        <div className="right-div">
          <img src="provide.webp" alt="Placeholder" className="right-image" />
        </div>
      </div>
      <div className="overlay-s">
        <div className="moving-text">
          {/* Render each text from the combined array */}
          {combinedTextArray.map((text, index) => (
            <span key={index}>{`* ${text} * `}</span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Started;
